export default __webpack_public_path__ + "static/heroSectionBg-d9b197af92a5796fd934e0dc2e1f5012.png";